import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { useTheme } from "@mui/material/styles";

import { useState } from "react";

import SortIcon from "@mui/icons-material/FilterList";
import CloseIcon from "@mui/icons-material/Close";
import ManaIconsFormatted from "../decklists/ManaIconsFormatted";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";

export default function PlayerIpadDecklist({ decklist, close }) {
    const theme = useTheme();

    const [orderBy, setOrderBy] = useState("CMC");
    const [sort, setSort] = useState("asc");

    return (
        <>
            <Stack
                sx={{
                    width: "100%",
                    height: "100%",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    color: "#fff",
                    backgroundColor: "rgba(50, 50, 50, 0.9)",
                    zIndex: 1000,
                    backdropFilter: "blur(8px)",
                    WebkitBackdropFilter: "blur(8px)",
                    overflowY: "auto",
                }}
            >

                <Box sx={{ position: "sticky", width: "100%", top: 0, zIndex: 999 }}>
                    <Button onClick={close} sx={{ position: "absolute", top: 10, right: 10, zIndex: 999 }} color="error" variant="contained"><CloseIcon /></Button>
                </Box>
                {decklist && (
                    <Box sx={{ width: '100%', mx: 'auto', p: 4 }}>

                        <Typography
                            variant='h3'
                            component='div'
                            sx={{
                                textTransform: "uppercase",
                                textAlign: "center",
                            }}
                        >
                            {decklist.Player.PlayerName}
                        </Typography>
                        <Typography
                            variant='h3'
                            component='div'
                            sx={{
                                textTransform: "uppercase",
                                mb: 2,
                                color: theme.palette.text.orange,
                                textAlign: "center",
                            }}
                        >
                            {decklist.DecklistName}
                        </Typography>

                        <Stack
                            direction='row'
                            spacing={2}
                            alignItems='center'
                            justifyContent='center'
                            sx={{ mb: 4 }}
                        >
                            <Button
                                size='small'
                                variant={orderBy == "CMC" ? "contained" : "outlined"}
                                color={orderBy == "CMC" ? "error" : "primary"}
                                onClick={() => setOrderBy("CMC")}
                            >
                                CMC
                            </Button>

                            <Button
                                size='small'
                                variant={orderBy == "CardName" ? "contained" : "outlined"}
                                color={orderBy == "CardName" ? "error" : "primary"}
                                onClick={() => setOrderBy("CardName")}
                            >
                                Card Name
                            </Button>

                            {sort == "asc" && (
                                <IconButton
                                    color='primary'
                                    size='small'
                                    variant={"outlined"}
                                    onClick={() => setSort("desc")}
                                >
                                    <SortIcon sx={{ transform: "rotate(180deg)" }} />
                                </IconButton>
                            )}

                            {sort == "desc" && (
                                <IconButton
                                    color='primary'
                                    size='small'
                                    variant={"outlined"}
                                    onClick={() => setSort("asc")}
                                >
                                    <SortIcon />
                                </IconButton>
                            )}
                        </Stack>

                        <Stack direction='row' spacing={2} justifyContent='center' width='100%'>
                            <Stack width='50%' sx={{ backgroundColor: 'rgba(0,0,0,0.2)', p: 2, borderRadius: 4 }}>
                                <Typography
                                    variant='h4'
                                    component='div'
                                    sx={{
                                        textTransform: "uppercase",
                                        color: theme.palette.text.dark,
                                        textAlign: "center",
                                    }}
                                >
                                    MAIN DECK
                                </Typography>

                                {_.orderBy(
                                    _.filter(decklist.Cards, function (card) {
                                        return card.Type.toLowerCase().indexOf("land") === -1;
                                    }),
                                    [orderBy],
                                    [sort]
                                ).map((row, i) => (
                                    <Box
                                        layout
                                        key={"card" + i}
                                        sx={{
                                            position: "relative",
                                            px: 1.2,
                                            pt: 0.85,
                                            pb: 0.6,
                                            mb: 0.4,
                                            fontSize: "1rem",
                                            lineHeight: "1rem",
                                        }}
                                    >
                                        <Stack direction='row' spacing={1} alignItems='center'>

                                            <Stack direction='row' spacing={1} justifyContent='space-between' alignItems='center' width='100%'>
                                                <Box sx={{ borderRadius: 1, overflow: 'hidden', minWidth: 80 }}>
                                                    <img src={"/cardimages/thumbs/" + row.FileName + ".jpg"} width='80' style={{ display: 'block' }} />
                                                </Box>
                                                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>{row.CardName}</Box>

                                                <ManaIconsFormatted
                                                    iconWidth={15}
                                                    mana={row.ManaCost}
                                                />
                                            </Stack>
                                        </Stack>
                                    </Box>
                                ))}

                                <Typography
                                    variant='h4'
                                    component='div'
                                    sx={{
                                        textTransform: "uppercase",
                                        mt: 4,
                                        mb: 2,
                                        color: theme.palette.text.dark,
                                        textAlign: "center",
                                    }}
                                >
                                    LANDS
                                </Typography>
                                {_.orderBy(
                                    _.filter(decklist.Cards, function (card) {
                                        return card.Type.toLowerCase().indexOf("land") > -1;
                                    }),
                                    ["CardName"],
                                    ["asc"]
                                ).map((row, i) => (
                                    <Box
                                        layout
                                        key={"card" + i}
                                        sx={{
                                            position: "relative",
                                            px: 1.2,
                                            pt: 0.85,
                                            pb: 0.6,
                                            mb: 0.4,
                                            fontSize: "1rem",
                                            lineHeight: "1rem",
                                        }}
                                    >
                                        <Stack direction='row' spacing={1} alignItems='center'>


                                            <Stack direction='row' spacing={1} justifyContent='space-between' alignItems='center' width='100%'>
                                                <Box sx={{ borderRadius: 1, overflow: 'hidden', minWidth: 80 }}>
                                                    <img src={"/cardimages/thumbs/" + row.FileName + ".jpg"} width='80' style={{ display: 'block' }} />
                                                </Box>
                                                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>{row.CardName}</Box>

                                                <ManaIconsFormatted
                                                    iconWidth={15}
                                                    mana={row.ManaCost}
                                                />
                                            </Stack>
                                        </Stack>
                                    </Box>
                                ))}

                            </Stack>
                            <Stack width='50%' sx={{ backgroundColor: 'rgba(0,0,0,0.5)', p: 2, borderRadius: 4 }}>
                                <Typography
                                    variant='h4'
                                    component='div'
                                    align='center'
                                    sx={{
                                        textTransform: "uppercase",
                                        color: theme.palette.text.dark,
                                        textAlign: "center",
                                    }}
                                >
                                    SIDEBOARD
                                </Typography>

                                {_.orderBy(decklist.Sideboard, [orderBy], [sort]).map(
                                    (row, i) => (
                                        <Box
                                            layout
                                            key={"sideboard" + i}
                                            sx={{
                                                position: "relative",
                                                px: 1.2,
                                                pt: 0.85,
                                                pb: 0.6,
                                                mb: 0.4,
                                                fontSize: "1rem",
                                                lineHeight: "1rem",
                                            }}
                                        >

                                            <Stack direction='row' spacing={1} justifyContent='space-between' alignItems='center' width='100%'>
                                                <Box sx={{ borderRadius: 1, overflow: 'hidden', minWidth: 80 }}>
                                                    <img src={"/cardimages/thumbs/" + row.FileName + ".jpg"} width='80' style={{ display: 'block' }} />
                                                </Box>
                                                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', width: '100%' }}>{row.CardName}</Box>

                                                <ManaIconsFormatted
                                                    iconWidth={15}
                                                    mana={row.ManaCost}
                                                />
                                            </Stack>
                                        </Box>
                                    )
                                )}
                            </Stack>
                        </Stack>
                    </Box>
                )}
            </Stack>
        </>
    );
}